export enum ContractorsRoute {
  CONTRACTORS_LIST = '/management-panel/contractors',
  ADD_CONTRACTOR = '/management-panel/contractors/add',
  IMPORT_RESULT = '/management-panel/contractors/import',
  CONTRACTOR_CARD = '/management-panel/contractors/:uuid',
  EDIT_CONTRACTOR = '/management-panel/contractors/:uuid/edit',
}
